import { useState } from 'react';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Box from '../../components/layout/Box';
import TextInput from '../../components/TextInput';
import PrivacyPolicyModal from '../Modals/DataPolicy';
import Button from '../../components/Button';
import ResendConfirmation from './ResendConfirmation';
import ErrorBox from '../../components/ErrorBox';
import CenteredPage from '../../containers/CenteredPage';

const SignInView = ({
  handleSignIn,
  isLoading,
  error,
  initialValues,
  validationSchema,
  username,
}) => {
  const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);

  const getError = () => {
    if (error) {
      switch (error) {
        case 'UserNotConfirmedException':
          return <ResendConfirmation username={username} />;
        case 'UserNotFoundException':
          return (
            <FormattedMessage defaultMessage="Användare kunde ej hittas" />
          );
        case 'NotAuthorizedException':
          return (
            <FormattedMessage defaultMessage="Felaktigt användarnamn eller lösenord" />
          );
        default:
          return (
            <FormattedMessage defaultMessage="Ett fel har inträffat. Var god försök igen." />
          );
      }
    }
  };

  return (
    <>
      <CenteredPage
        className="py-5 flex-column"
        style={{
          maxWidth: 520,
        }}
      >
        <h1 className="mb-3">
          <FormattedMessage defaultMessage="Logga in" />
        </h1>

        <Box className="w-100 flex-column">
          <Box className=" flex-column">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleSignIn(values);
              }}
            >
              {({ values, errors, handleChange, handleBlur, submitCount }) => {
                const showErrors = submitCount > 0;

                return (
                  <Form>
                    <TextInput
                      type="text"
                      name="email"
                      onChange={handleChange('email')}
                      onBlur={handleBlur}
                      value={values.email}
                      error={showErrors && errors.email}
                      placeholder="Email address"
                    />

                    <TextInput
                      type="password"
                      name="password"
                      onChange={handleChange('password')}
                      onBlur={handleBlur}
                      value={values.password}
                      error={showErrors && errors.password}
                      placeholder="Password"
                    />

                    {error && (
                      <ErrorBox
                        title={
                          <FormattedMessage defaultMessage="Fel vid inloggning" />
                        }
                        text={getError()}
                      />
                    )}

                    <Box className="flex-row w-100">
                      <div style={{ marginRight: 5 }}>
                        <FormattedMessage defaultMessage="Glömt ditt lösenord?" />
                      </div>
                      <Link to="/forgot-password">
                        <FormattedMessage defaultMessage="Klicka här" />
                      </Link>
                    </Box>

                    <Box className="flex-row w-100 mt-3 mb-2">
                      <Button expand type="submit" isLoading={isLoading}>
                        <FormattedMessage defaultMessage="Logga in" />
                      </Button>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          </Box>

          <Box className="mt-2">
            <FormattedMessage defaultMessage="Har du inte ett konto?" />
            <Link to="/sign-up" style={{ marginLeft: 5 }}>
              <FormattedMessage defaultMessage="Registrera dig här" />
            </Link>
          </Box>
        </Box>
      </CenteredPage>

      <PrivacyPolicyModal
        show={showPrivacyPolicyModal}
        setShow={setShowPrivacyPolicyModal}
      />
    </>
  );
};

export default SignInView;
